{
  "version": 1,
  "asset_id": "fa52f7a7-28da-4fbb-b6b6-8e6a6d0cece6",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/fa52f7a7-28da-4fbb-b6b6-8e6a6d0cece6/hernando-galvalume-metal-roof-destination-roofing-768w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/fa52f7a7-28da-4fbb-b6b6-8e6a6d0cece6/hernando-galvalume-metal-roof-destination-roofing-768w.webp",
  "original_filename": "hernando-galvalume-metal-roof-destination-roofing-768w.webp",
  "size": 91438,
  "content_type": "image/webp",
  "created_at": "2026-07-21T19:37:52Z"
}
